export const services = [
  {
    id: 1,
    icon: "PencilRuler",
    title: "Architectural Design and Drawing",
    description: "Comprehensive architectural plans and detailed drawings tailored to your vision and site requirements"
  },
  {
    id: 2,
    icon: "Ruler",
    title: "Structural Design and Drawing",
    description: "Structural engineering designs and drawings ensuring safety, stability, and compliance with standards"
  },
  {
    id: 3,
    icon: "Zap",
    title: "Electrical and Plumbing Design and Drawing",
    description: "Detailed electrical and plumbing designs and drawings for efficient and code-compliant systems"
  },
  {
    id: 4,
    icon: "Building2",
    title: "Construction of Residential, Commercial and Industrial Buildings",
    description: "End-to-end construction services for residential, commercial, and industrial projects with premium materials and expert craftsmanship"
  },
  {
    id: 5,
    icon: "RefreshCw",
    title: "Renovation Works",
    description: "Expert renovation services to transform and upgrade your existing property"
  },
  {
    id: 6,
    icon: "Compass",
    title: "Vastu Consultancy",
    description: "Expert Vastu consultancy to harmonize your space with natural elements and positive energy"
  },
  {
    id: 7,
    icon: "Building",
    title: "Facility Management",
    description: "Comprehensive facility management services for maintenance and efficient operation of your property"
  },
  {
    id: 8,
    icon: "HardHat",
    title: "Project Management Consultant",
    description: "Professional project management consultancy ensuring timely delivery within budget and quality standards"
  },
  {
    id: 9,
    icon: "Calculator",
    title: "Quantity Survey",
    description: "Accurate quantity surveying and cost estimation for effective budget planning and resource management"
  },
  {
    id: 10,
    icon: "ClipboardList",
    title: "Construction Planning",
    description: "Strategic construction planning and scheduling for efficient project execution and timely delivery"
  },
  {
    id: 11,
    icon: "FileText",
    title: "Tender Services (All tenders across India)",
    description: "Comprehensive tender preparation and submission services for construction projects across India"
  },
  {
    id: 12,
    icon: "FileCheck",
    title: "BBMP Building Licence",
    description: "Assistance in obtaining BBMP building licences and approvals with full documentation support"
  }
];

export const servicesProcess = [
  { step: "01", title: "Consultation", description: "Understanding your requirements, budget, and site conditions" },
  { step: "02", title: "Design", description: "Creating detailed architectural and structural plans" },
  { step: "03", title: "Construction", description: "Building with quality materials and expert supervision" },
  { step: "04", title: "Delivery", description: "Timely handover of your completed property" }
];

export const servicesWhyChooseUs = [
  {
    title: "Creative Innovation",
    description: "Bringing fresh design ideas and modern construction techniques to every project"
  },
  {
    title: "Technical Precision",
    description: "Meticulous attention to detail and structural excellence in all deliverables"
  },
  {
    title: "Client-Focused Collaboration",
    description: "Working closely with you at every stage to ensure your vision comes to life"
  },
  {
    title: "Vision to Reality",
    description: "Turning your dream home from concept to completion with seamless execution"
  }
];
